import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/index.js';

function SuperbadgeSetLabel({
  path,
  images,
  labels,
  complete
}) {
  return /*#__PURE__*/React.createElement("a", {
    href: path,
    className: "tds-superbadge-set-label slds-grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tds-superbadge-set-label__icon-container"
  }, images.map((image, i) => /*#__PURE__*/React.createElement("img", {
    key: /.+\/([^.]+)+\..+$/.exec(image)[1],
    src: image,
    height: "32px",
    width: "32px",
    alt: "",
    style: {
      zIndex: images.length - i
    },
    className: "tds-superbadge-set-label__icon"
  })), complete && /*#__PURE__*/React.createElement("div", {
    className: "tds-superbadge-set-label__check-container"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "check",
    assistiveText: {
      label: "complete"
    },
    category: "action",
    size: "x-small",
    containerClassName: "slds-p-around_xx-small tds-bg_success tds-icon-container_xx-small tds-superbadge-set-label__check",
    className: "tds-icon_xx-small"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "tds-text_bold"
  }, labels.name), "\xA0", /*#__PURE__*/React.createElement("span", null, labels.superSet)));
}
SuperbadgeSetLabel.displayName = "SuperbadgeSetLabel";
SuperbadgeSetLabel.defaultProps = {
  complete: false
};
const {
  shape,
  string,
  bool,
  arrayOf
} = PropTypes;
SuperbadgeSetLabel.propTypes = {
  path: string.isRequired,
  images: arrayOf(string).isRequired,
  labels: shape({
    name: string.isRequired,
    superSet: string.isRequired
  }).isRequired,
  complete: bool
};

export { SuperbadgeSetLabel as default };
